import {Workflow} from "common/flowmaster/types/workflow";
import ConfirmDialog from "common_components/confirm_dialog";
import React from "react";

type WorkflowLockConfirmDialogProps = {
  workflow: Workflow;
  open: boolean;
  onClose: () => void;
  onSuccess: () => void;
};

export const WorkflowLockConfirmDialog: React.FC<WorkflowLockConfirmDialogProps> = ({
  workflow,
  open,
  onClose,
  onSuccess,
}) => {
  const title = `${workflow.is_locked ? "Unlock" : "Lock"} Workflow \"${
    workflow.name
  }\"`;

  const description = `Are you sure you want to ${
    workflow.is_locked ? "unlock" : "lock"
  } this workflow?`;
  return (
    <ConfirmDialog
      open={open}
      onSuccess={() => onSuccess()}
      onClose={() => onClose()}
      title={title}
      description={description}
      okButtonCaption="Yes"
      cancelButtonCaption="No"
    />
  );
};
